import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  lan: string

  constructor(private router: Router, public translate: TranslateService) {
    // Register translation languages
    translate.addLangs(['en', 'it', 'pt', 'es', 'fr', 'el', 'hi']);
    // Set default language
    translate.setDefaultLang('en');
    
  
    this.lan =localStorage.getItem("lan")  

    if(this.lan == null){
      localStorage.setItem("lan", "en");
    }
    else{
      this.lan = localStorage.getItem('lan')
      translate.use(this.lan);
    }
      // console.log("language: " + this.lan); 
  }

  ngOnInit() {

  }

  home() {
    this.router.navigate(['/']);
  }
}

